"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author Tomas Leity
 */


var NChangedProdThresholdConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NChangedProdThresholdConverter, _NotificationDocConve);

  function NChangedProdThresholdConverter() {
    _classCallCheck(this, NChangedProdThresholdConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedProdThresholdConverter).apply(this, arguments));
  }

  return NChangedProdThresholdConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NChangedProdThresholdConverter = NChangedProdThresholdConverter;